import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { useIsMounted } from 'usehooks-ts';
import BlogCard from '@/features/blog/components/blog-card/blog-card';
import getRandomBlogPost from '@/features/blog/requests/get-random-blog-post';
import { type BlogPost } from '@/features/blog/types/blog-post-types';
import { listingsViewAtom } from '@/features/listing/atoms/listings-view-atom';
import { getCookieCurrentPlace } from '@/features/place/cookies/cookie-current-place';
export default function BlogCardListing() {
  const listingsView = useAtomValue(listingsViewAtom);
  const defaultLink = 'https://reactdev.roomster.com/blog';
  const defaultPost: BlogPost = {
    description: 'On our blog you can find tips and news about co-living, rooms for rent and roommates search.',
    id: 'defaultPost',
    imgUrl: '/images/blog/landing-offer-image-1.svg',
    link: defaultLink,
    title: 'Visit our blog',
    type: 'blogPost'
  };
  const [blogPost, setBlogPost] = useState<BlogPost>(defaultPost);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isMounted = useIsMounted();
  useEffect(() => {
    const currentPlace = getCookieCurrentPlace();
    if (currentPlace?.fullName) {
      getRandomBlogPost(currentPlace.fullName).then(post => {
        setBlogPost(post);
      }).catch(() => {
        setBlogPost(defaultPost);
      }).finally(() => {
        setIsLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted]);
  return <BlogCard blogPost={blogPost} isLoading={isLoading} listingsView={listingsView} showReadMoreButton />;
}